// extracted by mini-css-extract-plugin
export var container = "EditPrice-module--container--nlJ90";
export var content = "EditPrice-module--content--KGPmr";
export var footer = "EditPrice-module--footer--aT9cl";
export var input = "EditPrice-module--input--ATau3";
export var title = "EditPrice-module--title--jE6iW";